module.exports = __webpack_public_path__ + "img/neg-bridge-crossing.9da07ace.png";